export const colors = {
  actionBackground: '#FEA715',
  actionText: '#101820',
  cardBackgroundDark: '#101820',
  cardSurface: '#F8F5F1',
  cardBorder: '#E5E0D8',
  textMuted: '#D6D6D6',
  textSubtle: '#F2F4F7',
  textTimestamp: '#9CA3AF',
  textError: '#B91C1C',
  textLabel: '#4B5563',
  textValue: '#111827',
  textStatus: '#9A3412',
  textSubtitle: '#6B7280',
  textTitle: '#1F2937',
  // Legend (SpotLegend)
  legendBookedBorder: '#D1D1D8',
  legendCardBg: '#FFF',
  legendShadow: '#191C23',
  /** Web box-shadow layers (legend card) – same base as legendShadow with alpha */
  legendShadowLayer1: '#191C230F',
  legendShadowLayer2: '#191C2312',
  legendShadowLayer3: '#191C231A',
  legendText: '#2E2E2E',
  legendAvailableBorder: '#323946',
  /** Non-bookable spots on map + legend */
  legendNotBookableFill: '#323946',
  legendNotBookableBorder: '#323946',
  legendNotBookableLabel: '#FFFFFF',
  legendSelectedBg: '#EDECF8',
  legendSelectedBorder: '#4B46C1',
  /** Selected spot label text (same as border in current design; separate token for correct semantics). */
  legendSelectedText: '#4B46C1',
  legendAssignedBg: '#EDECF8',
  legendAssignedBorder: '#EDECF8',
  legendAssignedText: '#9D99D4',
  legendErrorBorder: '#DE243D',
  legendErrorText: '#DE243D',
  // ErrorState banner – 'danger' variant (Figma: Pampas/Lightest, Pampas/Primary, Kit/Primary)
  errorBannerBg: '#FBF1EC',
  errorBannerBorder: '#DD7B42',
  errorBannerText: '#323946',
  // ErrorState banner – 'error' variant (Figma)
  errorBannerErrorBg: '#FBE9EB',
  errorBannerErrorBorder: '#E24459',
  errorBannerErrorIcon: '#DE233C',
  /** Neutral info banner (e.g. server-assigned spot on selection screen). */
  infoBannerBg: '#F2F4F7',
  infoBannerBorder: '#9CA3AF',
  infoBannerText: '#323946',
  transparent: 'transparent',
  /** Scroll tutorial / modal scrim over the room map */
  tutorialOverlayBackground: 'rgba(0, 0, 0, 0.6)',
  tutorialOverlayText: '#FFFFFF'
};
